// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import API from './config/apiConfig' // 引入API 配置文件
import Util from './libs/util' // 引入公用工具包
import JSMpeg from './libs/jsmpeg.min'
import axios from 'axios' // 引入 axios
import ElementUI from 'element-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Vuex from 'vuex'
import VCharts from 'v-charts'
import store from './vuex/store'
import 'element-ui/lib/theme-chalk/index.css'


Vue.config.productionTip = false

// 设置全局http请求
let errorRun = (error) => {
  // 这里处理请求出错的场景
  ElementUI.Message({
    showClose: true,
    message: error,
    type: 'error'
  })
}

// 拦截request请求，配置请求参数
axios.interceptors.request.use(function (config) {
  store.state.isShow = true // 在请求发出之前loading显示
  let appStorage = store.state.appKey
  config.timeout = 10000 // 设置请求超时时长
  // 如果是登录页不需要mtk
  if (config.url.indexOf('userApi/login') === -1) {
    config.headers.mtk = Util.localData.getData('usermtk') // 设置请求用户token
    config.headers.mtd = Util.localData.getData('usermtd')
    let appKey = Util.localData.getData('appKey')
    let facesetName = Util.localData.getData('facesetName')
    if (!appKey) {
      appKey = appStorage
    }
    config.headers.appKey = ''
    if (appKey) {
      config.headers.appKey = appKey // 设置appKey
    }
    config.headers.facesetName = encodeURIComponent(facesetName)
  }
  return config
}, function (error) {
  errorRun(error)
  return Promise.reject(error)
})

// 拦截response 处理返回问题
axios.interceptors.response.use(function (response) {
  store.state.isShow = false // 在请求结束loading隐藏
  let data = response.data
  if (data.resMsg.length > 0 && data.resMsg[0].msgCode === '10005') {
    /* window.location.href = 'http://localhost:5511/' */
    router.push({
      path: '/login'
    })
    return
  } else if (data.resCode === 0) {
    errorRun(data.resMsg[0].msgText)
    return Promise.reject(data.resMsg[0].msgText)
  }
  return data
}, function (error) {
  errorRun(error)
  return Promise.reject(error)
})

// 定义Vue全局内容
Vue.prototype.$API = API // 配置全局使用的api接口
Vue.prototype.$Util = Util // 配置全局的工具类
Vue.prototype.$http = axios
Vue.prototype.$message = ElementUI.Message

/* import Mock from './api/mock' */

Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(VueAwesomeSwiper)
Vue.use(VCharts)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js